// massId yang AE consumption-nya disembunyiin dari tampilan (dashboard/fms, ReportSummary, Datalog).
// ponytail: hardcoded list buat kebutuhan demo, upgrade ke config backend kalo jadi kebutuhan permanen.
const AE_CONSUMPTION_HIDDEN_MASS_IDS = [109];

const isAeConsumptionHidden = (massId) => AE_CONSUMPTION_HIDDEN_MASS_IDS.includes(Number(massId));

// massId yang tabel AE/Flowmeter/Fuel Summary di ReportSummary-nya pake layout baru.
// ponytail: hardcoded per-asset karena baru dipakai satu vessel, upgrade kalo perlu dipasang massal.
const AE_FUEL_TABLE_REDESIGN_MASS_IDS = [109];

export const isAeFuelTableRedesigned = (massId) => AE_FUEL_TABLE_REDESIGN_MASS_IDS.includes(Number(massId));

export default isAeConsumptionHidden;
